import { backOff } from "exponential-backoff";

export * from './visits';
export * from './careRequirements';

export function retryFetch(fn: () => Promise<Response>, numOfAttempts = 3, startingDelay = 1000): Promise<Response> {
  // This wrapper around backOff has two purposes - first, to set sensible defaults on number of attempts and the delay,
  // and second to retry 500 status codes as well as network errors.

  let attempt = 1;
  return backOff(() => fn().then(r => {
    // If the backend returns a 500, fetch() still resolves. We want to throw an error, so that backOff will retry the request.
    // However, if this was the final attempt, we instead return the Response object, maintaining the same interface as fetch().
    // Thus the rather attempt counting, duplicating backOff's own logic.
    if (r.status >= 500 && attempt < numOfAttempts) {
      attempt++;
      throw new Error("Retrying")
    }
    return r;
  }), { numOfAttempts, startingDelay });
}
